import * as React from 'react';

import {
    SalesProcessAgent,
    EmailSequenceAgent,
    SalesObjectionAgent,
    LeadResearchAgent,
} from './agents';
import {useGetPageContext} from './graphql/hooks';
import {
    SALES_PROCESS_AGENT,
    EMAIL_SEQUENCE_AGENT,
    SALES_OBJECTION_AGENT,
    LEAD_RESEARCH_AGENT,
} from './helpers';
import type {AgentKey} from './helpers';

type Props = {
    agentKey: AgentKey;
    entityIdContext: string | null | undefined;
};

export function TeamAiAgentWrapper(props: Props) {
    const {context: pageContext} = useGetPageContext(props.entityIdContext);
    let context = pageContext;
    if (!props.entityIdContext) {
        context = '';
    }

    switch (props.agentKey) {
        case SALES_PROCESS_AGENT:
            return <SalesProcessAgent pageContext={context} />;
        case EMAIL_SEQUENCE_AGENT:
            return <EmailSequenceAgent />;
        case SALES_OBJECTION_AGENT:
            return <SalesObjectionAgent />;
        case LEAD_RESEARCH_AGENT:
            return <LeadResearchAgent pageContext={context} />;
        default:
            return null;
    }
}
